import React, { Component } from 'react'
import axios from "axios";
import * as ROUTES from "../constants/routes";
import DashBoard from "./DashBoard";
import WorkerStats from "./Admin/WorkerStats";
import {BACKEND_BASE_URL} from "../constants/routes";


export class Home extends Component {


  constructor(props) {
    super(props);
    this.state = {
      userDetails: {
        "availableBalance": 0,
          "commission": 0,
        "profilePicURL": "",
        "jobsCompleted": 0,
        "lifetimeEarnings": 0,
        "active": false,
          "language" : "en"
      }, user : this.props.user, stats: ''
    }
  }


  componentDidMount() {
      console.log(this.props.user.access)
    if(!this.props.user){
      this.props.history.push(ROUTES.LOGIN);
    }else{
      if(this.props.user.access !=="Admin") {
            axios.post(`${BACKEND_BASE_URL}/users/userInfo`, {
              "docId": this.props.user.userId,
              "phone": this.props.user.phone,
              "type": this.props.user.type
            }).then(result=>{
              console.log(result)
              this.setState({ userDetails: result.data.data})
            }).catch(e=>{

            })
      }

    }



    }

  render() {
          if(this.state.userDetails && this.props.user.access !="Admin"){
            const {commission,availableBalance,profilePicURL, jobsCompleted, lifetimeEarnings, active, language } = this.state.userDetails

            return (
                <div>

                  <DashBoard lifetimeEarnings={lifetimeEarnings} commission={commission} jobsCompleted={jobsCompleted} active={active} language={ language} />

                </div>
            )
          }
      if(this.props.user.access==="Admin") {
          const stats = this.state.stats
      console.log(this.state.stats)
                      return (
                          <div>

                            <WorkerStats stats={stats} user={this.props.user}/>

                          </div>
                      )
                    }
      else{
          return (
              <div>hahah</div>
          )
      }

    }
}

export default Home
